export enum PopupTypes {
  LoginOption,
  Form,
  Download,
  Leaving,
}
